import type { BasketState } from '@wecasa/common/src/ducks/common/basket';
import colors from '@wecasa/common/src/utils/colors';
import { getCurrentCountry } from '@wecasa/common/src/utils/country';
import { formatPrice, formatPricePerHour, formatPricePerMonth } from '@wecasa/common/src/utils/formatting';

import { MEMBERSHIP_CONFIG_BY_COUNTRY } from '@wecasa/customer/src/constants/country-config';
import type { Price } from '@wecasa/customer/src/types/prices';

import { translate } from '@wecasa/i18n';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';
import TextButton from '@wecasa/web-ui/src/components/button/text-button';

const t = translate('basket.membership.card');

type NotMemberWithSpotPrestationProps = {
  reduction: Price;
  getMoreInfoPress: () => void;
  duration: BasketState['duration'];
};

const NotMemberWithSpotPrestation = ({ reduction, getMoreInfoPress, duration }: NotMemberWithSpotPrestationProps) => {
  const membershipMonthlyPrice = MEMBERSHIP_CONFIG_BY_COUNTRY[getCurrentCountry()].monthlyPrice;

  const formattedPrice = duration
    ? formatPrice(reduction.price)
    : formatPricePerHour(reduction.hourly_price, { precision: 0 });

  return (
    <span>
      <Text.SMBold>{t('.cleaning.spot.is_not_yet_member.text_1')}</Text.SMBold>
      <Text.SMBold color={colors.pink120}>{` ${formattedPrice} `}</Text.SMBold>
      <Text.SMBold>{`${t('.cleaning.spot.is_not_yet_member.text_2')} `}</Text.SMBold>
      <Text.SM>{`${t('.cleaning.spot.is_not_yet_member.text_3', {
        pricePerMonth: formatPricePerMonth(membershipMonthlyPrice),
      })} `}</Text.SM>
      <TextButton size='sm' onClick={getMoreInfoPress}>
        {t('.more_info_link')}
      </TextButton>
    </span>
  );
};

export default NotMemberWithSpotPrestation;
